import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const AdminLogin = lazy(() => import('../pages/admin/login'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ContentProductionPage = lazy(() => import('../pages/content-production/page'));
const LiveStreamingPage = lazy(() => import('../pages/live-streaming/page'));
const OnSiteServicePage = lazy(() => import('../pages/on-site-service/page'));
const StudioConsultingPage = lazy(() => import('../pages/studio-consulting/page'));
const AIContentPage = lazy(() => import('../pages/ai-content/page'));
const IntegratedSolutionPage = lazy(() => import('../pages/integrated-solution/page'));
const UniversitySolutionPage = lazy(() => import('../pages/university-solution/page'));
const PublicSolutionPage = lazy(() => import('../pages/public-solution/page'));
const EnterpriseSolutionPage = lazy(() => import('../pages/enterprise-solution/page'));
const KRStoryPage = lazy(() => import('../pages/kr-story/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <HomePage />
      </Suspense>
    ),
  },
  {
    path: '/admin/login',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <AdminLogin />
      </Suspense>
    ),
  },
  {
    path: '/admin',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <AdminPage />
      </Suspense>
    ),
  },
  {
    path: '/content-production',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <ContentProductionPage />
      </Suspense>
    ),
  },
  {
    path: '/live-streaming',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <LiveStreamingPage />
      </Suspense>
    ),
  },
  {
    path: '/on-site-service',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <OnSiteServicePage />
      </Suspense>
    ),
  },
  {
    path: '/studio-consulting',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <StudioConsultingPage />
      </Suspense>
    ),
  },
  {
    path: '/ai-content',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <AIContentPage />
      </Suspense>
    ),
  },
  {
    path: '/integrated-solution',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <IntegratedSolutionPage />
      </Suspense>
    ),
  },
  {
    path: '/university-solution',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <UniversitySolutionPage />
      </Suspense>
    ),
  },
  {
    path: '/public-solution',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <PublicSolutionPage />
      </Suspense>
    ),
  },
  {
    path: '/enterprise-solution',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <EnterpriseSolutionPage />
      </Suspense>
    ),
  },
  {
    path: '/kr-story',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <KRStoryPage />
      </Suspense>
    ),
  },
  {
    path: '/news',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <NewsPage />
      </Suspense>
    ),
  },
  {
    path: '/portfolio',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <PortfolioPage />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="text-lg">Loading...</div></div>}>
        <NotFoundPage />
      </Suspense>
    ),
  },
];

export default routes;
